import type { HsToolActionType } from './tool-action-type.class';

export class HsToolAction {
  constructor(
    public readonly type: HsToolActionType,
    public readonly directions: number[],
    public readonly planes: number[],
    public min: number | null = null,
    public max: number | null = null
  ) {}
}
